import { defineMessages } from "react-intl";

const messages = defineMessages({
    modify: {
        id: "general.modify",
    },
    copied: {
        id: "input.copiedToTheClipboard",
    },
});

export default messages;
